import { Box, CircularProgress, Typography } from '@mui/material';
import { env } from '@/config/env';

/** Full-viewport loading state shown while the session bootstraps. */
export function SplashScreen({ message }: { message?: string }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {message ?? `Loading ${env.appName}…`}
      </Typography>
    </Box>
  );
}
